// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import global components
import Video from "../../../global/components/helpers/Video.js.jsx";
import videoUtils from "../../../global/utils/videoUtils.js";

// import node css modules
import nodeStyles from '../nodeModuleStyles.css';

function BuildSingleNodePreview({ node, onVideoComplete, scene }) {

  const videoSources = scene ? videoUtils.returnVideoSources(scene.videoUrl, scene.posterUrl, scene.tracks, scene._id) : [];

  return (
    <div>
      <p><strong>Follow-Up Order:</strong> {node.followUpOrder} </p>
      <p><strong>Authoring Code:</strong> {node.authoring.code} </p>
      <p><strong>NODE AT A GLANCE:</strong></p>
      <p><strong>Table of Contents?</strong> {node.toc ? "YES" : "NO"} </p>
      <p><strong>Exitable?</strong> {node.exit ? "YES" : "NO"} </p>
      <p><strong>Progress Checkpoint?</strong> {node.checkpoint ? "YES" : "NO"} </p>
      <p><strong>Question?</strong> {node.question ? "YES" : "NO"} </p>
      <p><strong>Answer?</strong> {node.answer ? `YES: - ${node.correct}` : "NO"} </p>
      <p><strong>Metric</strong> {node.metric} </p>
      <p><strong>Notes:</strong> {node.notes} </p>
    </div>
  )
}

BuildSingleNodePreview.propTypes = {
  node: PropTypes.object.isRequired
  , onVideoComplete: PropTypes.func
  , scene: PropTypes.object
}

export default BuildSingleNodePreview;



// WEBPACK FOOTER //
// modules/node/components/BuildSingleNodePreview.js.jsx